import { ApolloError } from "@apollo/client";

/*
 * Parse out the error message from the ApolloError
 * @param {ApolloError} error - The actual ApolloError object
 */
export const parseError = (error: ApolloError): string => {
    if (error.networkError) {
        return error.networkError.message;
    }

    if (error.graphQLErrors) {
        return error.graphQLErrors[0].message;
    }

    return "Unknown server error";
};
